import { render, staticRenderFns } from "./GroupAlertBehaviorEditor.vue?vue&type=template&id=70d5aefc&"
import script from "./GroupAlertBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./GroupAlertBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports